var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-wrapper"},[(_vm.shouldShowAlert)?_c('alert',{attrs:{"alertContent":_vm.alertContent},on:{"alertButtonClick":_vm.closeAlertModal}}):_vm._e(),_c('description',{attrs:{"content":this.content}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }